<template>
  <NotificationItem 
    @bind-telegram="openTelegramModal"
    :isSystemMessage="true"
    :data="{
      notification_from_user:{
        name: 'Кэпитал',
        avatar: DROPS_ICON,
        profile_url: '/'
      },
      comment: 'Привяжите телеграм аккаунт в Настройках профиля, чтобы получить доступ в Кэпитал Work чат, Кэпитал Meme, Кэпитал Alerts.',
    }"
  />
</template>

<script setup>
  import { useRouter } from 'vue-router';
  import { PATHS_NAME } from '@shared/routers/consts/pathsName';
  import { useNotificationsDropdown } from '@/Groups/Notifications/private/imports/toggleDropdown';
  //---------------------------
  import NotificationItem from '@/Groups/Notifications/private/ui/NotificationItem/NotificationItem.vue';
  //---------------------------
  const router = useRouter();
  //---------------------------
  const { close } = useNotificationsDropdown();
  //---------------------------
  const DROPS_ICON = require('@/Groups/Notifications/private/media/drops.png');
  //---------------------------
  const openTelegramModal = () => {
    close();
    router.push({ name: PATHS_NAME.USER.SETTINGS });
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>